import React, { useEffect, useState } from 'react'
import MultiSelectOption from './Components/MultiSelectOption';
import './MultiSelectDropDownNew.css'

/**
 * Reusable component for multi select dropdown
 * @param {*} props 
 * @returns 
 */
const MultiSelectDropDownNew = (props) => {
    const {options,placeholder,id,filterSelected,setFilterSelected,loading} = props;
    const [showDD,setShowDD] = useState(false)
    const [checkStatus,setCheckStatus] = useState([]);
    const [tempFilterSelected,setTempFilterSelected] = useState(filterSelected);

    /**
     * useEffect to form check status data on change filters selected
     */
    useEffect(()=>{
        formCheckStatus()
        setTempFilterSelected(filterSelected)
    },[filterSelected])

    useEffect(()=>{
        if (options && options.length > 0) {
            formCheckStatus()
        }
    },[tempFilterSelected])

    /**
     * function to toggle dropdown
     */
    const toggleDD=(e)=>{
        e.stopPropagation()
        if (!loading) {
            setShowDD(!showDD)
            if (!showDD) {
                setTempFilterSelected(filterSelected)
            }
        }
    }

    /**
     * Function to check is already selected
     * @param {*} list 
     * @param {*} ele 
     * @returns 
     */
    const isAlreadySelected=(list,ele)=>{
        let filteredData=list?.filter((data)=>data===ele)
        return filteredData.length ? true :false
    }

    /**
     * Fucntion to select filter
     * @param {*} data 
     */
    const onSelected=(data) => {
       if (data==='All') {
        let allFilters= []
        if (isAlreadySelected(tempFilterSelected,data)) {
            allFilters.push(placeholder)
        }else{
            options?.forEach((el)=>{
                allFilters.push(el.name);
            })
        }      
        setTempFilterSelected(allFilters)
       }else{
        if (isAlreadySelected(tempFilterSelected,data)) {
            let newFilters=tempFilterSelected?.filter((el)=>el!==data && el!=='All')
            setTempFilterSelected(newFilters)
        }else{
            let newFilters=tempFilterSelected?.filter((el)=>el!=='All')
            if (newFilters.length === options.length-2) {
                let fullFilters=[]
                 options?.forEach((el)=>{
                    fullFilters.push(el.name);
                })
                setTempFilterSelected(fullFilters)
            }else{
            setTempFilterSelected([...newFilters,data])
            }
        }
    }
    }

    /**
     * Function to render filter selected text
     * @returns 
     */
    const displayFilterSelected=()=>{        
        let text=""
        if (filterSelected && filterSelected.length) {
            if (!filterSelected.includes("All")) {
                filterSelected.forEach((el)=>{
                    if (el) {
                        text=text+el+", "
                    }
            })
            }else{
                text='All, '
            }
         }
        else{
            text=placeholder
        }    
        text=text.slice(0,-2)
        if (text.length>15) {
            return text.slice(0,15)+"..."
        }
       return text 
    }

    /**
     * Function to form check status data
     */
    const formCheckStatus=()=>{
        let status=[];
        options.forEach((el)=>{
          
                let list=tempFilterSelected.filter((filter)=>filter===el.name)
                if (list && list.length===0) {
                    status.push(false)
                }else{
                    status.push(true)
                }
            
           
        })
        setCheckStatus(status);
    }


    const handleApply=(e)=>{
        e.stopPropagation()
        if (!tempFilterSelected || tempFilterSelected.length === 0) {
   setFilterSelected([placeholder])
        } else {
            setFilterSelected(tempFilterSelected)
        }
        setShowDD(false)
    }


    const handleCancel=(e)=>{
        e.stopPropagation()
        setTempFilterSelected(filterSelected)
        setShowDD(false)
    }


    const handleDropdownClick=(e)=>{
        e.stopPropagation()
    }

  return (
    <div className='multi-select-dropdown' id={id} onClick={toggleDD} disabled={loading}>

    <span className='multi-select-display-text'>{displayFilterSelected()}</span>
    <span className='arrow-container-dd'>{showDD?<i className="fa-solid fa-angle-up"></i>:<i className="fa-solid fa-angle-down"></i>}</span>
    <div  className='multi-select-trigger' >
        {showDD && !loading &&
        <div className='multi-select-dd' onClick={handleDropdownClick}>
        {options.map((el,index)=>{
            return(
               <MultiSelectOption
               data={el}
               isSelected={checkStatus[index]}
               onSelected={onSelected}
               /> 
            )
        })}
        <div className='multi-select-buttons'>
            <button className='cancel-btn' onClick={handleCancel}>Cancel</button>
            <button className='apply-btn' onClick={handleApply}>Apply</button>
        </div>
        </div>}
        </div>
    </div>
  )
}

export default MultiSelectDropDownNew